<template>
    <div class="el-tooltip command-button"  @click="doSetAppoint">
        <el-tooltip  effect="dark" :content="$t('main.InsertSpaceFiller')" placement="top">
            <span style="display: inline-block;font-size: 12px;width:22px !important; font-weight: bold;white-space: nowrap;">
                插入
            </span>
        </el-tooltip>
    </div>
</template>

<script>
import { mapState } from "vuex"
export default {
    // 插入填空符
    name: "insertSpaceFillerComponent",
    data() {
        return {
        }
    },
    computed:{
    },
    watch: {
    },
    created() {
    },
    methods: {
        doSetAppoint() {
            this.$emit("click", '______');
        }
    }
};
</script>

<style lang="scss" scoped>
.el-icon-edit-outline{
    font-weight: bold !important;
}
.command-button{
    border: 1px solid transparent;
    box-sizing: border-box;
    align-items: center;
    border-radius: 50%;
    color: #303133;
    cursor: pointer;
    display: flex;
    justify-content: center;
    height: 40px;
    margin: 2px;
    outline: 0;
    transition: all .2s ease-in-out;
    width: 27px !important;
    height: 18px !important;
}
</style>